import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "cinema-slide__content other hide-scrollbar disable-overscroll-y"
};
const _hoisted_2 = {
  key: 1,
  class: "wrapper"
};
const _hoisted_3 = {
  key: 0,
  class: "loading"
};
const _hoisted_4 = {
  key: 1,
  class: "loading"
};
import { useDeviceStore } from '@remote/store/device';
import CinemaListItem from '@remote/components/cinema/CinemaListItem.vue';
import CinemaEmpty from '@remote/components/cinema/CinemaEmpty.vue';
import { IconLoading2 } from '@xunlei/thunder-icon-vue';
import { stat } from '@remote/utils/stat';
import { watch } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'CinemaSlideOther',
  props: {
    isShowing: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const deviceStore = useDeviceStore();
    watch(() => props.isShowing, () => {
      if (props.isShowing) {
        var _deviceStore$currentN, _deviceStore$currentN2;
        stat({
          action: 'cinema_channel_show',
          data: {
            if_content_blank: ((_deviceStore$currentN = deviceStore.currentNFOInstance) === null || _deviceStore$currentN === void 0 ? void 0 : _deviceStore$currentN.otherList.length) === 0 ? 1 : 0,
            page: 'other',
            status: (_deviceStore$currentN2 = deviceStore.currentNFOInstance) !== null && _deviceStore$currentN2 !== void 0 && _deviceStore$currentN2.isScraping ? 1 : 0
          }
        });
      }
    });
    return (_ctx, _cache) => {
      var _unref$currentNFOInst, _unref$currentNFOInst2, _unref$currentNFOInst3, _unref$currentNFOInst4, _unref$currentNFOInst5, _unref$currentNFOInst6, _unref2, _unref$currentNFOInst7;
      const _directive_observer = _resolveDirective("observer");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [((_unref$currentNFOInst = _unref(deviceStore).currentNFOInstance) === null || _unref$currentNFOInst === void 0 ? void 0 : _unref$currentNFOInst.otherList.length) === 0 ? (_openBlock(), _createBlock(CinemaEmpty, {
        key: 0,
        "has-list-init": _unref(deviceStore).currentNFOInstance.hasOtherListInit
      }, null, 8, ["has-list-init"])) : (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_unref$currentNFOInst2 = _unref(deviceStore).currentNFOInstance) === null || _unref$currentNFOInst2 === void 0 ? void 0 : _unref$currentNFOInst2.otherList, item => {
        var _item$video_info;
        return _openBlock(), _createBlock(CinemaListItem, {
          key: (_item$video_info = item.video_info) === null || _item$video_info === void 0 ? void 0 : _item$video_info.file_id,
          nfo: item,
          "click-from": "other"
        }, null, 8, ["nfo"]);
      }), 128)), !((_unref$currentNFOInst3 = _unref(deviceStore).currentNFOInstance) !== null && _unref$currentNFOInst3 !== void 0 && _unref$currentNFOInst3.isOtherListEnd) && !((_unref$currentNFOInst4 = _unref(deviceStore).currentNFOInstance) !== null && _unref$currentNFOInst4 !== void 0 && _unref$currentNFOInst4.isScraping) ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_unref(IconLoading2), {
        width: "16",
        height: "16"
      }), _createTextVNode(" 加载中... ")])), [[_directive_observer, {
        show: (_unref$currentNFOInst5 = _unref(deviceStore).currentNFOInstance) === null || _unref$currentNFOInst5 === void 0 ? void 0 : _unref$currentNFOInst5.loadOtherNFOList
      }]]) : _createCommentVNode("", true), ((_unref$currentNFOInst6 = (_unref2 = _unref(deviceStore)) === null || _unref2 === void 0 || (_unref2 = _unref2.currentNFOInstance) === null || _unref2 === void 0 || (_unref2 = _unref2.otherList) === null || _unref2 === void 0 ? void 0 : _unref2.length) !== null && _unref$currentNFOInst6 !== void 0 ? _unref$currentNFOInst6 : 0) >= 30 && (_unref$currentNFOInst7 = _unref(deviceStore).currentNFOInstance) !== null && _unref$currentNFOInst7 !== void 0 && _unref$currentNFOInst7.isOtherListEnd ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 没有更多了～ ")) : _createCommentVNode("", true)]))]);
    };
  }
});